document.addEventListener('DOMContentLoaded', function() {
  function initializeImageNavigation() {
    const navs = document.querySelectorAll('.card-image-nav');

    navs.forEach((nav) => {
      // Verifica se o nav está visível (mobile only - max-width: 850px)
      const computedStyle = window.getComputedStyle(nav);
      const isVisible = computedStyle.display !== 'none';
      
      if (!isVisible) return;

      const card = nav.closest('.card');
      if (!card) return;

      const media = card.querySelector('.card__media .media');
      if (!media) return;

      const images = media.querySelectorAll('img');
      if (images.length <= 1) return;

      // Remove opacity styles para deixar o CSS do hover funcionar no desktop
      images.forEach((img) => {
        img.style.opacity = '';
      });

      let currentIndex = 0;
      const prevBtn = nav.querySelector('.card-image-arrow--prev');
      const nextBtn = nav.querySelector('.card-image-arrow--next');

      function show(index) {
        if (index < 0) {
          currentIndex = images.length - 1;
        } else if (index >= images.length) {
          currentIndex = 0;
        } else {
          currentIndex = index;
        }

        images.forEach((img, i) => {
          img.style.opacity = i === currentIndex ? '1' : '0';
        });
      }

      // Inicializa primeira imagem visível
      show(0);

      prevBtn?.addEventListener('click', () => show(currentIndex - 1));
      nextBtn?.addEventListener('click', () => show(currentIndex + 1));
    });
  }

  // Inicializa após carregamento dos estilos
  if (document.readyState === 'loading') {
    document.addEventListener('readystatechange', () => {
      if (document.readyState === 'interactive') {
        initializeImageNavigation();
      }
    });
  } else {
    initializeImageNavigation();
  }

  // Re-inicializa ao redimensionar a janela (para quando mudar de mobile para desktop)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initializeImageNavigation, 250);
  });
});

